module.exports = __webpack_public_path__ + "static/media/favicon.6d5b01d3.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nx/favicon.ico
// module id = 767
// module chunks = 0